import axiosClient from ".";
class DepositHistoryAPI {
  static get_deposit_histories_data(currentPage) {
    return axiosClient.get(`/api/v1/transaction/deposits?page=${currentPage}`);
  }
}
export default DepositHistoryAPI;
